import "$styles/index.css"
import "./medicion.js"

// Fichas del manual: hover o foco en un control ilumina su zona en la
// captura y viceversa (los tres elementos de un control comparten data-ctl).
const menosMovimiento = window.matchMedia("(prefers-reduced-motion: reduce)")

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".vista").forEach((vista) => {
    const grupo = (id) => vista.querySelectorAll(`[data-ctl="${id}"]`)
    const encender = (id, desdeLista) => {
      grupo(id).forEach((el) => el.classList.add("hot"))
      if (!desdeLista) {
        vista.querySelector(`.ctl[data-ctl="${id}"]`)?.scrollIntoView({
          block: "nearest",
          behavior: menosMovimiento.matches ? "auto" : "smooth",
        })
      }
    }
    // sigue encendido mientras otro elemento del grupo tenga hover o foco
    const apagar = (id) => {
      const els = [...grupo(id)]
      if (els.some((el) => el.matches(":hover, :focus-within"))) return
      els.forEach((el) => el.classList.remove("hot"))
    }

    vista.querySelectorAll("[data-ctl]").forEach((el) => {
      const desdeLista = el.classList.contains("ctl")
      el.addEventListener("mouseenter", () => encender(el.dataset.ctl, desdeLista))
      el.addEventListener("mouseleave", () => apagar(el.dataset.ctl))
      el.addEventListener("focusin", () => encender(el.dataset.ctl, desdeLista))
      el.addEventListener("focusout", () => apagar(el.dataset.ctl))
    })
  })
})

// Buscador: Pagefind se genera post-build sobre output/, así que se carga como
// script suelto (no lo puede resolver esbuild) y puede no existir en dev.
document.addEventListener("DOMContentLoaded", () => {
  const el = document.querySelector("#buscador")
  if (!el) return
  const script = document.createElement("script")
  script.src = "/pagefind/pagefind-ui.js"
  script.onload = () => {
    new window.PagefindUI({
      element: "#buscador",
      showSubResults: true,
      showImages: false,
      autofocus: true,
      translations: {
        placeholder: "facturar remisiones, F5250, corte de caja…",
        zero_results: "Nada para «[SEARCH_TERM]». Intenta con la Clave Advanta o el nombre de la pantalla.",
        load_more: "Ver más resultados",
      },
    })
  }
  script.onerror = () => {
    el.innerHTML = "<p class='pagefind-ui__message'>El índice de búsqueda se genera al publicar el sitio.</p>"
  }
  document.head.appendChild(script)
})
